import { white } from "assets/styleUtils";
import { ICompany } from "data/company";
import FullScreenModal from "modal/FullScreenModal/FullScreenModal";
import React, { useEffect, useState } from "react";
declare global {
  interface Window {
    openModal: () => void;
    closeModal: () => void;
    isModalOpen: boolean;
  }
}

const ImageItem = ({ companyData }: { companyData?: ICompany }) => {
  const products = companyData?.product || [];
  const remainingCount = products.length - 5;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalIndex, setModalIndex] = useState(0);
  const images = products.flatMap((item) => item.img_url);
  useEffect(() => {
    window.openModal = () => {
      setIsModalOpen(true);
    };

    window.closeModal = () => {
      setIsModalOpen(false);
    };

    const messageHandler = (e: any) => {
      if (e.data === "MODAL_CLOSE") {
        setIsModalOpen(false);
      }
    };
    document.addEventListener("message", messageHandler);

    return () => {
      document.removeEventListener("message", messageHandler);

      window.openModal = () => {};
      window.closeModal = () => {};
    };
  }, []);
  const openModal = (index: number) => {
    setModalIndex(index);
    setIsModalOpen(true);
    window.history.pushState(null, "", window.location.href);
    window.openModal();
  };

  const closeModal = () => {
    setIsModalOpen(false);
    window.closeModal();
  };
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ width: "100%" }} onClick={() => openModal(0)}>
        <img
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
          src={products[0].img_url}
        />
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", width: "100%" }}>
        {products.map((value, index) => {
          if (index > 0 && index < 3) {
            return (
              <img
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  backgroundColor: white,
                  marginTop: "10px",
                }}
                src={value.img_url}
                onClick={() => openModal(index)}
              />
            );
          } else {
            if (index >= 3 && index < 6) {
              return (
                <div
                  key={index}
                  style={{
                    position: "relative",
                    width: "calc(50% - 5px)",
                    marginTop: "10px",
                    marginRight: index % 2 === 0 ? "0px" : "10px",
                  }}
                  onClick={() => openModal(index)}
                >
                  <img
                    style={{
                      width: "100%",
                      height: "300px",
                      objectFit: "cover",
                      backgroundColor: white,
                    }}
                    src={value.img_url}
                  />
                  {index === 5 && remainingCount > 0 && (
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "white",
                        fontSize: "18px",
                      }}
                    >
                      +{remainingCount}
                    </div>
                  )}
                </div>
              );
            }
          }
          return null;
        })}
      </div>
      <FullScreenModal
        images={images}
        initialIndex={modalIndex}
        isOpen={isModalOpen}
        onClose={closeModal}
      />
    </div>
  );
};

export default ImageItem;
